import {all, call, put, takeLatest} from "redux-saga/effects";
import {
  createEventCalendar,
  deleteEventCalendar,
  updateEventCalendar,
  getEventCalendarList,
  hideEventCalendar,
  showEventCalendar,
  setCreateEventCalendarResult,
  setDeleteEventCalendarResult,
  setUpdateEventCalendarResult,
  setHideEventCalendarResult,
  setEventCalendarListResult
} from "../../reducers/eventCalendarReducer/eventCalendarReducer";
import {PayloadAction} from "@reduxjs/toolkit";
import {
  EventCalendarApiEventCalendarListRequest,
  EventCalendarApiEventCalendarListResponse,
  EventCalendarApiEventCalendarCreateRequest,
  EventCalendarApiEventCalendarCreateResponse,
  EventCalendarApiEventCalendarUpdateRequest,
  EventCalendarApiEventCalendarUpdateResponse,
  EventCalendarApiEventCalendarDeleteRequest,
  EventCalendarApiEventCalendarDeleteResponse,
  EventCalendarApiEventCalendarHideRequest,
  EventCalendarApiEventCalendarHideResponse,
  EventCalendarApiEventCalendarShowRequest,
  EventCalendarApiEventCalendarShowResponse,
  EventCalendarEntity,
  PageModel,
} from "../../../proto/generated/api_entities_pb";
import {API} from "../../../API/API";
import {getErrorMessageByCode} from "../../../utils/constans/errorCodes/errorCodes";
import {
  IEventCalendarListRequest,
  IEventCalendarCreateRequest,
  IEventCalendarUpdateRequest,
  IEventCalendarDeleteRequest,
  IEventCalendarHideRequest,
  IEventCalendarShowRequest
} from "../../reducers/eventCalendarReducer/eventCalendarReducerTypes";
import {mapIEventCalendarToEventCalendarEntity} from "../../reducers/eventCalendarReducer/eventCalendarMappers";


function* getEventCalendarListSaga({payload}: PayloadAction<IEventCalendarListRequest>) {
  const req = new EventCalendarApiEventCalendarListRequest();
  
  const pageModel = new PageModel();
  pageModel.setPage(payload.pageModel.page);
  pageModel.setLimit(payload.pageModel.limit);
  req.setPagemodel(pageModel);

  // if (payload.countryId !== undefined) {
  //   req.setCountryid(payload.countryId);
  // }

  // if (payload.planeTypeId !== undefined) {
  //   req.setPlanetypeid(payload.planeTypeId);
  // }

  if (payload.dateFrom !== undefined) {
    req.setDatefrom(payload.dateFrom);
  }

  if (payload.dateTo !== undefined) {
    req.setDateto(payload.dateTo);
  }

  if (payload.isActive !== undefined) {
    req.setIsactive(true);
  }

  if (payload.source !== undefined) {
    req.setSource(payload.source);
  }

  if (payload.seasonType !== undefined) {
    req.setSeasontype(payload.seasonType);
  }

  if (payload.hasSeasonType !== undefined) {
    req.setHasseasontype(payload.hasSeasonType);
  }

  try {
    const res: EventCalendarApiEventCalendarListResponse = yield call(API.getEventCalendarList, req);
    const resultResponse = res.getResultresponse();

    if (resultResponse?.getIssuccessful()) {
      yield put(setEventCalendarListResult({
        items: res.getEventsList(),
        totalCount: res.getTotalcount(),
      }))
    } else {
      yield put(setEventCalendarListResult({
        items: [],
        totalCount: 0,
      }))
    }
  } catch (error: any) {
    yield put(setEventCalendarListResult({
      items: [],
      totalCount: 0,
    }))
  }
}


function* createEventCalendarSaga({payload}: PayloadAction<IEventCalendarCreateRequest & {requestTimestamp?: number}>) {
  try {
    const eventCalendarEntity = mapIEventCalendarToEventCalendarEntity({
      ...payload.eventCalendar,
      eventCalendarId: 0,
      createdAt: '',
      updatedAt: '',
    } as any);

    const req = new EventCalendarApiEventCalendarCreateRequest();
    req.setEventcalendar(eventCalendarEntity);

    const res: EventCalendarApiEventCalendarCreateResponse = yield call(API.createEventCalendar, req);
    const resultResponse = res.getResultresponse();

    console.log('[eventCalendarSaga] createEventCalendar response:', {
      isSuccessful: resultResponse?.getIssuccessful(),
      errorMessage: resultResponse?.getErrormessage(),
      hasEventCalendar: res.hasEventcalendar(),
      eventCalendar: res.getEventcalendar(),
    });

    if (resultResponse?.getIssuccessful()) {
      const eventCalendar = res.getEventcalendar();
      console.log('[eventCalendarSaga] Success! Dispatching setCreateEventCalendarResult with item:', eventCalendar);
      yield put(setCreateEventCalendarResult({
        item: res.getEventcalendar(),
        requestTimestamp: payload.requestTimestamp,
      }))
    } else {
      console.log('[eventCalendarSaga] Error! Dispatching setCreateEventCalendarResult with errorMessage');
      yield put(setCreateEventCalendarResult({
        errorMessage: getErrorMessageByCode(resultResponse?.getErrormessage() || ''),
      }))
    }
  } catch (error: any) {
    yield put(setCreateEventCalendarResult({
      errorMessage: getErrorMessageByCode(error?.code),
    }))
  }
}


function* updateEventCalendarSaga({payload}: PayloadAction<IEventCalendarUpdateRequest>) {
  try {
    const eventCalendarEntity = mapIEventCalendarToEventCalendarEntity(payload.eventCalendar);

    const req = new EventCalendarApiEventCalendarUpdateRequest();
    req.setEventcalendar(eventCalendarEntity);

    const res: EventCalendarApiEventCalendarUpdateResponse = yield call(API.updateEventCalendar, req);
    const resultResponse = res.getResultresponse();

    if (resultResponse?.getIssuccessful()) {
      yield put(setUpdateEventCalendarResult({
        item: res.getEventcalendar(),
      }))
    } else {
      yield put(setUpdateEventCalendarResult({
        errorMessage: getErrorMessageByCode(resultResponse?.getErrormessage() || ''),
      }))
    }
  } catch (error: any) {
    yield put(setUpdateEventCalendarResult({
      errorMessage: getErrorMessageByCode(error?.code),
    }))
  }
}


function* deleteEventCalendarSaga({payload}: PayloadAction<IEventCalendarDeleteRequest>) {
  try {
    const req = new EventCalendarApiEventCalendarDeleteRequest();
    req.setEventcalendarid(payload.eventCalendarId);

    const res: EventCalendarApiEventCalendarDeleteResponse = yield call(API.deleteEventCalendar, req);
    const resultResponse = res.getResultresponse();

    if (resultResponse?.getIssuccessful()) {
      yield put(setDeleteEventCalendarResult({
        eventCalendarId: payload.eventCalendarId,
      }))
    } else {
      yield put(setDeleteEventCalendarResult({
        errorMessage: getErrorMessageByCode(resultResponse?.getErrormessage() || ''),
      }))
    }
  } catch (error: any) {
    yield put(setDeleteEventCalendarResult({
      errorMessage: getErrorMessageByCode(error?.code),
    }))
  }
}

function* hideEventCalendarSaga({payload}: PayloadAction<IEventCalendarHideRequest>) {
  try {
    const req = new EventCalendarApiEventCalendarHideRequest();
    req.setEventcalendarid(payload.eventCalendarId);

    const res: EventCalendarApiEventCalendarHideResponse = yield call(API.hideEventCalendar, req);
    const resultResponse = res.getResultresponse();

    if (resultResponse?.getIssuccessful()) {
      yield put(setHideEventCalendarResult({
        eventCalendarId: payload.eventCalendarId,
      }));
    } else {
      yield put(setHideEventCalendarResult({
        eventCalendarId: payload.eventCalendarId,
        errorMessage: getErrorMessageByCode(resultResponse?.getErrormessage() || ''),
      }));
    }
  } catch (error: any) {
    yield put(setHideEventCalendarResult({
      eventCalendarId: payload.eventCalendarId,
      errorMessage: getErrorMessageByCode(error?.code),
    }));
  }
}

function* showEventCalendarSaga({payload}: PayloadAction<IEventCalendarShowRequest>) {
  try {
    const req = new EventCalendarApiEventCalendarShowRequest();
    req.setEventcalendarid(payload.eventCalendarId);

    const res: EventCalendarApiEventCalendarShowResponse = yield call(API.showEventCalendar, req);
    const resultResponse = res.getResultresponse();

    if (resultResponse?.getIssuccessful()) {
      yield put(showEventCalendar({eventCalendarId: payload.eventCalendarId}));
      // Перезагружаем список, чтобы показать событие
      yield put(getEventCalendarList({
        pageModel: {page: 0, limit: 100},
      }));
    } else {
      // Ошибка обрабатывается через message.error в компоненте
    }
  } catch (error: any) {
    // Ошибка обрабатывается через message.error в компоненте
  }
}

export function* eventCalendarSaga() {
  yield all([
    takeLatest(getEventCalendarList.type, getEventCalendarListSaga),
    takeLatest(createEventCalendar.type, createEventCalendarSaga),
    takeLatest(updateEventCalendar.type, updateEventCalendarSaga),
    takeLatest(deleteEventCalendar.type, deleteEventCalendarSaga),
    takeLatest(hideEventCalendar.type, hideEventCalendarSaga),
    takeLatest(showEventCalendar.type, showEventCalendarSaga),
  ]);
}

